module.exports = __webpack_public_path__ + "img/ssl-monitoring.f38d2c49.png";